'use strict'

// babel polyfill
import 'core-js/stable'

import $ from 'jquery'
// define
import EL from './constant/elements'

// helper
import hmb from './helper/hmb'
import form from './helper/form'
import uaDataset from './helper/uaDataset'
import sweetScrollInit from './helper/sweetScrollInit'
import getTouchSupport from './helper/getTouchSupport'
import getDocumentH from './helper/getDocumentHeight'
import getOrientation from './helper/getOrientation'
import getClassName from './helper/getClassName'
import set100vh from './helper/set100vh'
import smoothScroll from './helper/smoothScroll'
import flicking from './helper/flickingInit'
import accordion from './helper/accordion'

import movie from '../images/video/watada.mp4'

// plugins
import objectFitImages from 'object-fit-images'
import picturefill from 'picturefill'
import Stickyfill from 'stickyfilljs'
import { throttle, debounce } from 'throttle-debounce'

// page scripts
import pageNameTop from './page/top'
import page from './page/page'

// require
require('intersection-observer')
require('focus-visible')
require('matchheight')
require('svgxuse')

// ua
let ua = null

// className
let className = null

// lastInnerWidth
let lastInnerWidth = window.innerWidth

// innerHeight
let innerHeight = window.innerHeight

// isPopStateEvent
const isPopStateEvent = false

const isScrolling = 0
let timeoutId

/**
 * getScrollPos
 */
const getScrollPos = () => {
  const y = Math.round(window.pageYOffset)
  const offset = className === 'top' ? innerHeight : 200
  const documentH = getDocumentH()

  // add class is-scroll
  if (y > 0) {
    if (!EL.HTML.classList.contains('is-scroll')) {
      EL.HTML.classList.add('is-scroll')
    }
  } else {
    EL.HTML.classList.remove('is-scroll')
  }

  // add class is-footer
  if (documentH <= y) {
    if (!EL.HTML.classList.contains('is-footer')) {
      EL.HTML.classList.add('is-footer')
    }
  } else {
    EL.HTML.classList.remove('is-footer')
  }
}

/**
 * resize
 */
const resize = () => {
  // set100vh（常に更新）
  set100vh('--vh-always')

  // window高さが高くなった時
  if (window.innerHeight > innerHeight) {
    set100vh('--vh-max')
  }

  // window幅が変わった時
  if (lastInnerWidth !== window.innerWidth) {
    lastInnerWidth = window.innerWidth

    // set100vh
    set100vh()
  }

  innerHeight = window.innerHeight
}

// spmenu
const menu = document.querySelectorAll('.toggle')
const menuPc = document.querySelectorAll('.toggle_pc')

function toggleSp () {
  const content = this.nextElementSibling
  this.classList.toggle('is-active')
  content.classList.toggle('is-open')
}

function togglePc () {
  const content = $(this).find('.menu_ul')
  this.classList.toggle('is-active')
  content.toggleClass('is-open')
}

function toggleOut () {
  const content = $(this).find('.menu_ul')
  this.classList.toggle('is-active')
  content.toggleClass('is-open')
}

for (let i = 0; i < menu.length; i++) {
  menu[i].addEventListener('click', toggleSp)
}

for (let i = 0; i < menuPc.length; i++) {
  menuPc[i].addEventListener('mouseover', togglePc)
  menuPc[i].addEventListener('mouseout', toggleOut)
}

/**
 * firstRun
 */
const firstRun = () => {
  // set ua dataset
  ua = uaDataset()

  // set touch support dataset
  ua.touchsupport = getTouchSupport()

  // getOrientation
  getOrientation()

  // Polyfill object-fit
  objectFitImages()

  // Polyfill picturefill
  picturefill()

  // set100vh
  set100vh()

  // set100vh（常に更新）
  set100vh('--vh-always')
}

/**
 * initOnce
 */
const initOnce = () => {
  // sweetScroll
  sweetScrollInit()

  // smoothScroll
  smoothScroll(ua)

  // hmb menu
  hmb()

  // form
  form()

  // ejgs::Flicking
  flicking()

  // accordion
  accordion()
}

/**
 * initRun
 */
const initRun = () => {
  // set100vh
  set100vh()

  // set100vh（常に更新）
  set100vh('--vh-always')

  // get body className
  className = getClassName(EL.BODY)

  // stickyfilljs
  Stickyfill.add(EL.STICKY)

  // getScrollPos
  getScrollPos()

  // top
  if (className.endsWith('top')) pageNameTop()

  EL.HTML.classList.add('is-loaded')
}

/**
 * DOMCONTENTLOADED
 */
window.addEventListener('DOMContentLoaded', firstRun)

/**
* LOAD
*/
window.addEventListener('load', initOnce)
window.addEventListener('load', initRun)

/**
* SCROLL
*/
window.addEventListener('scroll', throttle(100, getScrollPos), false)

window.addEventListener('scroll', function () {
  document.getElementById('floating').classList.add('hidden')

  clearTimeout(timeoutId)

  timeoutId = setTimeout(function () {
    if (window.pageYOffset !== 0) {
      document.getElementById('floating').classList.remove('hidden')
    }
  }, 500)
})

/**
* RESIZE
*/
window.addEventListener('resize', debounce(50, resize), false)

$(function () {
  $('[href^="#"]').click(function () {
    const href = $(this).attr('href')
    const target = $(href === '#' || href === '' ? 'html' : href)
    const position = target.offset().top - $('.l-header').innerHeight()
    $('html, body').animate({ scrollTop: position }, 600, 'swing')
    return false
  })
})
